import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import NewPatients from '@/pages/new-patients/new-patients'
import YourPerfectTreatment from '@/pages/your-perfect-treatment/your-perfect-treatment'
import CreatingYourSmile from '@/pages/creating-your-smile/creating-your-smile'
import LifeWithBraces from '@/pages/life-with-braces/life-with-braces'
import PatientContests from '@/pages/patient-contests/patient-contests'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility/accessibility'
import Covid19 from '@/pages/covid-19/covid-19'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import Styleguide from '@/styleguide/styleguide'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home
    },
    {
      path: '/new-patients',
      name: 'New Patients',
      navigation: true,
      component: NewPatients
    },
    {
      path: '/your-perfect-treatment',
      name: 'Your Perfect Treatment',
      navigation: true,
      component: YourPerfectTreatment
    },
    {
      path: '/creating-your-smile',
      name: 'Creating Your Smile',
      navigation: true,
      component: CreatingYourSmile
    },
    {
      path: '/life-with-braces',
      name: 'Life With Braces',
      navigation: true,
      component: LifeWithBraces
    },
    {
      path: '/patient-contests',
      name: 'Patient Contests',
      navigation: true,
      component: PatientContests
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      navigation: false,
      component: ThankYou
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/covid-19',
      name: 'Covid 19',
      navigation: false,
      component: Covid19
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js